export default {"src":"/_next/static/media/veryHappy_24.a8fd2782.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};